const Browser = {
  isAndroid () {
    return !!navigator.userAgent.match(/Android/i);
  },
  // isMobileQQ: function () {
  //   var ua = navigator.userAgent;
  //   return (
  //     /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(ua) ||
  //     /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(ua)
  //   );
  // },
  isIOS () {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  isWx () {
    return !!navigator.userAgent.match(/micromessenger/i);
  },
  isChrome () {
    return !!(
      navigator.userAgent.match(/Chrome\/([\d.]+)/) ||
      navigator.userAgent.match(/CriOS\/([\d.]+)/)
    );
  },
  isBaidu () {
    return !!navigator.userAgent.match(/baidubrowser/i);
  },
  isUC () {
    return !!navigator.userAgent.match(/UCBrowser/i);
  },
  isSafari () {
    return !!navigator.userAgent.match(/safari/i);
  },
  isQQBrowser () {
    return !!navigator.userAgent.match(/MQQBrowser/i);
  },
  isWeibo () {
    return !!navigator.userAgent.match(/weibo/i);
  },
  isAlipay () {
    return !!navigator.userAgent.match(/Alipay/i);
  },
};

export default Browser;
